document.querySelectorAll('.separators').forEach((separator) => {

    separator.addEventListener('mouseover', () => {
        const target = separator.getAttribute('data-target');

        document.querySelectorAll('.media-item')
            .forEach(item => item.classList.remove('active'));

        const el = document.getElementById(target);
        if (el) el.classList.add('active');
    });

    separator.addEventListener('mouseout', () => {
        document.querySelectorAll('.media-item')
            .forEach(item => item.classList.remove('active'));

        const first = document.querySelector('.media-item');
        if (first) first.classList.add('active');
    });

});